export const SPACE = " ";
export const DEFAULT_ANIMATION_SPEED = 200;
